import React from 'react'
import './CreditCardSnippet.css'

const CreditCardSnippetUI = ({context, ccLast4}) =>
  <div className='c_cc_snp'>
    <label>{ccLast4}</label>
    <div className="icon icon-caret-right"></div>
  </div>

export default CreditCardSnippetUI
